import { PermissionsScope } from '../policies/policy.model'

export const ATTRIBUTE_GROUP_DEFAULT_CODE = 'ALL'
export const ATTRIBUTE_GROUP_SCOPE: PermissionsScope = 'products'
